// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__Soce0","buttons":"RemoveExpirationActionButtons_buttons__915fQ"};